import TextareaAutosize from "react-textarea-autosize";
import cx from "../../utils/tailwind-merge";

export const Textarea = (props) => {
  const { ref, className, readOnly, disabled, draggable = false, ...restProps } = props;
  return (
    <TextareaAutosize
      ref={ref}
      draggable={draggable}
      readOnly={readOnly}
      disabled={disabled}
      className={cx(
        "textarea outline-0 bg-[#F0F0F0] border-none text-xs font-medium text-primary-text px-[10px] py-[6px] rounded-[5px] w-full",
        (readOnly || disabled) && "bg-secondary-250 cursor-not-allowed",
        className,
      )}
      {...restProps}
    />
  );
};


export default Textarea;
